import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import CoScholasticGradeCard from "./CoScholasticGradingCard";
import Loader from "../../Shared/Loader/Loader";
import { useCatchResponse } from '../../../utils/useCatchResponse';
import CommonConfig from "../../../utils/constant";

const CoScholasticGradeEntry = (props) => {
    const { catchResponse } = useCatchResponse();
    const [students, setStudents] = useState([]);
    const navigate = useNavigate();
    const [securityUserID, setSecurityUserID] = useState("");
    const [currentStudentIndex, setCurrentStudentIndex] = useState(0);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetGradeMarksList(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
    }, []);

    const GetGradeMarksList = async (id) => {
        try {
            let data = {
                UserID: id,
                ClassId: props?.location?.state?.classId,
                CoScholasticTemplateId: props?.location?.state?.coScholasticTemplateId,
                FinancialId: props?.location?.state?.financialId
            };
            Loader.show();
            const response = await api.post(APIConstant.path.GetGradeEntryList, data);
            if (response.success) {
                setStudents(response.data);
            }
            Loader.hide();
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleNext = () => {
        if (currentStudentIndex < students.length - 1) {
            setCurrentStudentIndex(currentStudentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStudentIndex > 0) {
            setCurrentStudentIndex(currentStudentIndex - 1);
        }
    };

    const handleGradeUpdate = (studentId, detailRow, termId, gradeValue) => {
        const updatedStudents = students.map((student) => {
          if (student.StudentId !== studentId) return student;
      
          return {
            ...student,
            GradeDetails: student.GradeDetails.map((gradeDetail) => {
              const updatedDetails = gradeDetail.Details.map((detail) => {
                if (detail !== detailRow) return detail;
      
                return {
                  ...detail,
                  Terms: detail.Terms.map((term) =>
                    term.TermId === termId ? { ...term, Grade: gradeValue ?? '' } : term
                  ),
                };
              });
      
              return { ...gradeDetail, Details: updatedDetails };
            }),
          };
        });
        setStudents(updatedStudents);
      };
      
    const AddGradeEntryData = async (isGraft) => {
        try {
            const updatedStudents = students?.map((student) => (
                { ...student, IsGraft: isGraft, FinancialId: props?.location?.state?.financialId, CreatedBy: securityUserID })
            );
            await api.post(APIConstant.path.AddUpdateGradingEntry, updatedStudents).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: res.message });
                    navigate('/co-scholastic-grading')
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err); 
            catchResponse(err);
        }
    };

    return (
        <div className="wayment-owner-dashboard et-master-page e-weighment-dashboard">
            <div className="heading-area flex justify-between items-center">
                <div className="flex items-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/co-scholastic-grading')}></i>
                    <h2 className="ml-2">{props?.location?.state?.className}</h2>
                </div>
            </div>
            <hr />
            <TabView>
                <TabPanel header="INDIVIDUAL">
                    <div>
                        <div className="flex justify-between items-center my-4">
                            <Paginator
                                first={currentStudentIndex}
                                rows={1}
                                totalRecords={students.length}
                                onPageChange={(e) => setCurrentStudentIndex(e.first)}
                            />
                        </div>
                        {students.length > 0 && (
                            <CoScholasticGradeCard student={students[currentStudentIndex]} onGradeChange={handleGradeUpdate} isAllow={props?.location?.state?.isAllow} isEdit={props?.location?.state?.isEdit}/>
                        )}
                        <div className="flex justify-between mt-4">
                            <Button
                                label="Previous"
                                className="p-button-secondary"
                                onClick={handlePrevious}
                                disabled={currentStudentIndex === 0}
                            />
                            <div className="flex justify-end gap-3 mt-4">
                                <Button label="Cancel" onClick={(e) => navigate('/co-scholastic-grading')} className="p-button-outlined p-button-secondary" />
                                {(props?.location?.state?.isEdit) && 
                                <><Button label="Save as Draft" className="p-button-secondary" onClick={(e) => AddGradeEntryData(true)} />
                                <Button label="Submit All" className="p-button-primary" onClick={(e) => AddGradeEntryData(false)} />
                                </>}
                            </div>
                            <Button
                                label="Next"
                                className="p-button-secondary"
                                onClick={handleNext}
                                disabled={currentStudentIndex === students.length - 1}
                            />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="COMPARE" />
            </TabView>
        </div>
    );
};

export default CoScholasticGradeEntry;
